import NotFound from "common/NotFound";
import { SwitchButton } from "components/form";
import React, { useState } from "react";
import { TbTruckDelivery } from "react-icons/tb";
import { PopupModal } from "components/modals/ModalBox";
import useButtonLoader from "hooks/useButtonLoader";
import { updateDeliveryStatusApi, deletedApi } from "services/masterApi";
import { deliverySlotsTabs } from "utils/componentValue/MasterValue";
import { FaEdit, FaRegTrashAlt, FaTrash } from "react-icons/fa";
import TimePicker from "react-time-picker";
import DatePicker from "react-datepicker";
import UpdateSlot from "./UpdateSlot";
import DeleteSlot from "./deleteSlot";

const DeliverySlots = ({
  manageDeliveryList = [],
  setManageDeliveryList = () => { },
  onHide,
  slotType,
  getsManageDeliverySlots = () => { },
  handleSlotTabChange = () => { },
}) => {
  const [selectedData, setSelectedData] = useState({});
  const [changeStatusModal, setChangeStatusModal] = useState(false);
  const [buttonLoader, setButtonLoader] = useButtonLoader("Yes");
  const [AddSlotModal, setAddSlotModal] = useState({ modal: false });
  const [selectedBrandDetail, setSelectedBrandDetail] = useState({});
  const [deleteModal, setDeleteModal] = useState(false);

  // ------change-status------------
  const handleChange = (data) => {
    setSelectedData(data);
    setChangeStatusModal(true);
  };
  // ------slot-modal------------
  const handleSlotModal = (data, type) => {
    setAddSlotModal({ ...data, type, modal: true });
  };

  // ------close add model
  const closeModel = () => {
    setSelectedBrandDetail({});
    setDeleteModal(false);
  };
  const handleDelete = async (data) => {
    await deletedApi(data?._id);
    // listing();   // refresh list
    // close();
  };

  return (
    <div className="table-container">
      <div className="tabContainer">
        <div className="set_btn">
          <ul>
            {deliverySlotsTabs.map((tabData) => (
              <li
                key={tabData.id}
                className={tabData.value === slotType ? "active" : "un-active"}
                onClick={() => handleSlotTabChange(tabData.value)}
              >
                {tabData.name}
              </li>
            ))}
          </ul>
          <button className="button" onClick={() => handleSlotModal(null, "Add")}>
            Add
          </button>
        </div>

      </div>


      <table className="table custom_table">
        <thead>
          <tr>
            {/* <th className="nowrap text-center">S.No</th> */}
            <th className="nowrap text-center">Timings</th>
            <th className="nowrap text-center">Action</th>
          </tr>
        </thead>
        <div></div>
        <tbody>
          {manageDeliveryList && manageDeliveryList.length > 0 ? (
            manageDeliveryList?.map((data, index) => {
              return (
                <tr key={index}>
                  {/* <td className="nowrap text-center">
                    {index + 1}
                  </td> */}
                  <td className="nowrap text-center">{data?.title}</td>
                  <td className="nowrap text-center">
                    <div className="button-container">
                      <div onClick={() => handleChange(data)}>
                        <SwitchButton
                          status={data?.status === "ACTIVE" ? true : false}
                        />
                      </div>
                      <button
                        type="button"
                        onClick={() => handleSlotModal(data, "Update")}
                      >
                        <FaEdit />
                      </button>

                      <button
                        type="button"
                        onClick={() => {
                          setSelectedBrandDetail(data);
                          setDeleteModal(true);
                        }}
                      >
                        <FaRegTrashAlt />
                      </button>
                    </div>
                  </td>
                </tr>
              );
            })
          ) : (
            <NotFound
              cols={3}
              msg={"Delivery Slot Not Found"}
              onHide={onHide}
              icon={<TbTruckDelivery />}
            />
          )}
        </tbody>
      </table>
      <PopupModal
        show={changeStatusModal}
        handleClose={() => setChangeStatusModal(false)}
        content={`Are you sure you want to ${selectedData?.status === "ACTIVE" ? "Deactivate" : "Activate"} it?`}
        title="Change Delivery Slot Status"
        buttonLoader={buttonLoader}
        action={() =>
          updateDeliveryStatusApi(
            selectedData?._id,
            selectedData?.status === "ACTIVE" ? "INACTIVE" : "ACTIVE",
            null, // value,
            setButtonLoader,
            () => setChangeStatusModal(false),
            null, //ApiRefresh,
            manageDeliveryList,
            setManageDeliveryList,
            null, //setLoadingId
          )
        }
      />

      <UpdateSlot
        show={AddSlotModal?.modal}
        close={() => setAddSlotModal({ modal: false })}
        data={AddSlotModal}
        slotType={slotType}
        listing={getsManageDeliverySlots}
      />

      <DeleteSlot
        show={deleteModal}
        data={selectedBrandDetail}
        close={closeModel}
        listing={getsManageDeliverySlots}
      />
    </div>
  );
};

export default DeliverySlots;
